microflow.factory("microflowFac", [
  "$http",
  "authenFac",
  "$timeout",
  function ($http, authenFac, $timeout) {
    let getAuthenHeader = function () {
      return new Promise(function (resolve, reject) {
        let localHeader = JSON.parse(localStorage.getItem("header"));
        if (localHeader === undefined || localHeader == null) {
          $timeout(function () {
            localHeader = JSON.parse(localStorage.getItem("header"));
            let headerObj = null;
            let header = { "Content-Type": undefined };

            if (localHeader != undefined) {
              headerObj = {};
              for (let key in localHeader) {
                headerObj[key] = "Bearer " + localHeader[key];
              }
            }
            if (headerObj != null) {
              header = Object.assign(header, headerObj);
            }
            resolve(header);
          }, 1000);
        } else {
          let headerObj = null;
          let header = { "Content-Type": undefined };
          if (localHeader != undefined) {
            headerObj = {};
            for (let key in localHeader) {
              headerObj[key] = "Bearer " + localHeader[key];
            }
          }
          if (headerObj != null) {
            header = Object.assign(header, headerObj);
          }
          resolve(header);
        }
      });
    };
    let doFlowAction = function (data, scope, loading) {
      return new Promise((resolve, reject) => {
        if (!(__pgd__ && __pgd__.env && __pgd__.env.MICROFLOW_REST_URL)) {
          reject("Error because environment [MICROFLOW_REST_URL] not set");
          return;
        }
        let headerObj = null;
        getAuthenHeader().then(function (inObj) {
          headerObj = inObj;
          if ($http.defaults.headers.common["Authorization"] == undefined) {
            $http.defaults.headers.common["Authorization"] = headerObj.Authorization;
          }
          if (loading) {
            if (loading === "spinner") {
              let loadSpinner = window.LOADING_SPINNER;
              let loadOptions = typeof loadSpinner === "string" ? JSON.parse(loadSpinner) : loadSpinner;
              $.LoadingOverlay("show", loadOptions);
            } else if (loading === "progress") {
              let loadProgress = window.LOADING_PROGRESS;
              let loadOptions = typeof loadProgress === "string" ? JSON.parse(loadProgress) : loadProgress;
              $.LoadingOverlay("show", loadOptions, "progress");
              $.LoadingOverlay("progressauto");
            }
          }

          $http({
            method: "POST",
            url: __pgd__.env.MICROFLOW_REST_URL,
            data: data,
          }).then(
            function successCallback(response) {
              let objRes = response.data;
              if (objRes.responseStatus === "SUCCESS") {
                let objMapp = objRes.responseObjectsMap;
                let objFlowName = objRes.flowName;
                for (let key in objMapp) {
                  if (key !== "iamHeader" && key !== "localStorage" && key != "permissionRole") {
                    if (scope.Store[objFlowName] === undefined) {
                      scope.Store[objFlowName] = {};
                    }
                    scope.Store[objFlowName][key] = objMapp[key];
                  } else {
                    if (key === "iamHeader") {
                      localStorage.setItem("header", JSON.stringify(objMapp[key]));
                    } else if (key === "localStorage") {
                      localStorage.setItem("appStorage", JSON.stringify(objMapp[key]));
                    } else if (key === "permissionRole") {
                      let perms = objMapp[key].Permission;
                      if (perms !== undefined) {
                        let permRole = perms.role;
                        let permObjectAccesses = perms.objectAccesses;
                        let roles = [];
                        let objectAccesses = [];

                        for (const element of permRole) {
                          roles.push(element.role_name);
                        }
                        authenFac.userRoles = roles;
                        for (const element of permObjectAccesses) {
                          objectAccesses.push(element);
                        }
                        if (objectAccesses.length > 0) {
                          authenFac.isLogin = true;
                        }
                        authenFac.objectAccesses = objectAccesses;
                      }
                    }
                  }
                }
                scope.update();
                if (loading) {
                  if (loading === "spinner") {
                    $.LoadingOverlay("hide");
                  } else if (loading === "progress") {
                    $.LoadingOverlay("hide", false, "progress");
                  }
                }
                resolve(objRes);
              } else if (objRes.responseStatus === "FAIL") {
                if (loading) {
                  if (loading === "spinner") {
                    $.LoadingOverlay("hide");
                  } else if (loading === "progress") {
                    $.LoadingOverlay("hide", false, "progress");
                  }
                }
                reject(objRes);
              } else {
                if (loading) {
                  if (loading === "spinner") {
                    $.LoadingOverlay("hide");
                  } else if (loading === "progress") {
                    $.LoadingOverlay("hide", false, "progress");
                  }
                }
                reject(objRes);
              }
            },
            function errorCallback(response) {
              if (loading) {
                if (loading === "spinner") {
                  $.LoadingOverlay("hide");
                } else if (loading === "progress") {
                  $.LoadingOverlay("hide", false, "progress");
                }
              }
              reject(response);
            }
          );
        });
      });
    };
    return {
      doFlowAction: doFlowAction,
    };
  },
]);
